import {makeAutoObservable, observable} from "mobx";
import {injectable} from "inversify";

export interface IFantasyStore {
	get selectedPlayerId(): number | null;
	set selectedPlayerId(value: number | null);
}

@injectable()
export class FantasyStore implements IFantasyStore {
	@observable private _selectedPlayerId: number | null = null;

	get selectedPlayerId() {
		return this._selectedPlayerId;
	}

	set selectedPlayerId(value: number | null) {
		this._selectedPlayerId = value;
	}

	constructor() {
		makeAutoObservable(this);
	}
}
